import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { AccountKycService } from 'src/app/services/kyc/account-kyc.service';

declare var bootstrap: any;

export interface NinVerificationData {
  firstName: string;
  middleName: string;
  surname: string;
  birthDate: string;
  gender: string;
}

@Component({
  selector: 'app-nin-verification-popup',
  templateUrl: './nin-verification-popup.component.html',
  styleUrls: ['./nin-verification-popup.component.scss'],
})
export class NinVerificationPopupComponent {
  @Input() nin: string | null | undefined;
  @Input() accountId: number | null | undefined = 0;

  @ViewChild('ninModal') ninModal: ElementRef;

  ninData: NinVerificationData | null = null;
  loading: boolean = false;
  errorMessage: string = '';

  private modalInstance: any;

  constructor(private accountKycService: AccountKycService) {}

  openModal() {
    if (!this.nin || !this.accountId) {
      return;
    }

    this.loading = true;
    this.errorMessage = '';
    this.ninData = null;

    this.modalInstance = new bootstrap.Modal(this.ninModal.nativeElement);
    this.modalInstance.show();

    this.accountKycService
      .getNinVerificationData(this.accountId)
      .subscribe({
        next: (response: any) => {
          if (response?.status === 'OK' && response?.data) {
            this.ninData = response.data;
          } else {
            this.errorMessage =
              response?.message || 'NIN verification data not available.';
          }
          this.loading = false;
        },
        error: () => {
          this.errorMessage = 'Failed to fetch NIN verification details.';
          this.loading = false;
        },
      });
  }

  closeModal() {
    this.modalInstance?.hide();
  }
}
